var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thread__author-avatar",class:_vm.sizeClass,style:(_vm.colorStyle)},[_vm._v(" "+_vm._s(_vm.getInitials)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }